export default "__VITE_ASSET__CfZi__$m__$_?nuxt_component=async&nuxt_component_name=SvgoCommonEn&nuxt_component_export=default__"